module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team/teachers/karolina-dd31f9b756ed264636a5f1bcf585e711.webp";